<input type="file" class="file-input" [accept]="acceptedFiles" (change)="onFileSelected($event)" #fileUpload>

<div class="file-upload">

    <!-- Mostrar la imagen si imageUrl tiene un valor -->
    <img *ngIf="imageUrl" [src]="imageUrl" class="uploaded-image" />

    <!-- Botón con el ícono de clip de Material Icons -->
    <button *ngIf="!imageUrl" (click)="fileUpload.click()" class="upload-btn">
        <i class="material-icons text-white">attach_file</i>
    </button>

    <button mat-flat-button color="accent" *ngIf="imageUrl" (click)="fileUpload.click()">{{ 'REPLACE' |
        translate}}</button>

</div>